export default {
	"order.SigningFailedPleaseSignAgain": "签约失败,请重新签约",
	"order.TheDeductionWasUnsuccessfulAndTheOrderListIsBeingRedirected": "扣款未成功，正在跳转订单列表",
	"order.PleaseConfirmThatYouHaveReadAndAgree": "请确认您已阅读并同意",
	"order.UserServicesAgreement": "《用户服务协议》",
	"order.return": "返回",
	"order.agreeAndContinue": "同意并继续",
	"order.MallCashierPagepaymentMethod": "商城收银台页_支付方式",
	"order.WeChat": "微信",
	"order.Alipay": "支付宝",
	"order.MallCashierPageorderButton": "商城收银台页_下单按钮",
	"order.SorryPricesHaveChanged": "抱歉，价格已发生变化!",
	"order.SystemErrorPleaseTryAgainLater": "系统错误,请稍后再试",
	"order.AlipaySignedAContract": "支付宝签约",
	"order.recommend": "推荐",
	"order.MallCashierPagePaymentConfirmationPopup": "商城收银台页_支付确认弹窗",
	"order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent": "支付后需要回来确认支付结果，确保购买内容顺利发放!",
	"order.PaymentAmount": "支付金额",
	"order.readAndAgree": "已阅读并同意",
	"order.AlipayScanCodeSigningContract": "支付宝扫码签约",
	"order.GoToAlipayToSignAContract": "前往支付宝签约",
	"order.cancelPayment": "取消支付",
	"order.waitForPayment": "等待支付…",
	"order.MallCashierPagepaymentConfirmationPopupconfirmationButton": "商城收银台页_支付确认弹窗_确认按钮",
	"order.Paid": "已支付",
	"order.PaymentIsSuccessfulGoToReceive": "支付成功，去领取",
	"order.unpaid": "未支付",
	"order.PaymentFailedRePay": "支付失败，重新支付",
	"order.MallCashierPagePaymentConfirmationPopupCloseButton": "商城收银台页_支付确认弹窗_关闭按钮",
	"order.ConfirmationOfPaymentResult": "支付结果确认中",
	"order.RequestingPayment": "请求支付中..."
}